import NGIcon from 'src/styles/theme/components/NGIcon';
import NGTooltip from 'src/styles/theme/components/NGTooltip';
import styled from 'styled-components';

export const StyledHotkey = styled.p(
	({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.grey};
    background-color: ${theme.colors.lead};
    border-radius: ${theme.radius.s};
    width: fit-content;
    font-size: 14px;
    line-height: 16px;
    min-width: 16px;
    padding: 0 ${theme.spacing['6xs']};
  `
);

export const StyledText = styled.p`
	color: ${({ theme }) => theme.colors.gold};
	padding: 0;
	font-size: 14px;
	line-height: 17px;
`;

export const NGIconEx = styled(NGIcon)(
	({ theme }) => `
    height: 16px;
    width: 14px;
    margin: 0 -${theme.spacing['6xs']} 0 -${theme.spacing['6xs']};
  `
);

export const NGTooltipEx = styled(NGTooltip)<{ inactive?: boolean }>(
	({ theme, inactive }) => `
    ${
			inactive
				? `
            ${StyledText} {
              color: ${theme.colors.lead};
            }

            &::before {
                background-image: unset;
                background: ${theme.colors.grey} !important;
              }
            }
          `
				: ''
		}
  `
);

export const StyledWrapper = styled.div`
	& > button[disabled] {
		pointer-events: none;
	}
`;
